import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private router: Router,
    private title: Title,
    private meta: Meta
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateMetaTags(event.urlAfterRedirects);
      }
    });
  }

  private updateMetaTags(url: string) {
    if (url.startsWith('/about-us')) {
      this.title.setTitle('About Us - Cyclops Defense');
      this.meta.updateTag({
        name: 'description',
        content: 'Learn more about Cyclops Defense, our mission, vision, approach, who we serve, and leadership team.'
      });

    } else if (url.startsWith('/solution')) {
      this.title.setTitle('Solutions - Cyclops Defense');
      this.meta.updateTag({
        name: 'description',
        content: 'Explore Cyclops Defense solutions including UAVs, border security, ISR, MRO services, licensing, and more.'
      });

    } else if (url.startsWith('/whycyclops')) {
      this.title.setTitle('Why Cyclops - Cyclops Defense');
      this.meta.updateTag({
        name: 'description',
        content: 'Discover why Cyclops Defense is trusted: capabilities, advantages, and regional market strategy.'
      });

    } else if (url.startsWith('/contact')) {
      this.title.setTitle('Contact Us - Cyclops Defense');
      this.meta.updateTag({
        name: 'description',
        content: 'Get in touch with Cyclops Defense for inquiries, collaborations, and partnerships.'
      });

    } else {
      // Default (homepage or other)
      this.title.setTitle('Cyclops Defense');
      this.meta.updateTag({
        name: 'description',
        content: 'Cyclops Defense provides advanced defense and security solutions, operations, and international partnerships.'
      });
    }

    // Always set canonical dynamically
    this.setCanonicalURL('https://cyclopsdefense.com' + url);
  }

  private setCanonicalURL(url: string) {
    let link: HTMLLinkElement =
      document.querySelector("link[rel='canonical']") || document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    document.head.appendChild(link);
  }
}
